import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Radio";
const Radio = memo(themed(Icon));
export {
  Radio
};
//# sourceMappingURL=radio.js.map
